import Vue from 'vue'
import App from './App.vue'
import './assets/main.css'
import { createPinia, PiniaVuePlugin } from 'pinia'
import ChartBlock from 'echarts-vue-component'
Vue.use(ChartBlock)
// 引入路由
import VueRouter from 'vue-router'
//router是在src路径下新建的文件夹（后面会提到）
import router from './router'
Vue.use(VueRouter)
import { createPersistedState } from 'pinia-persistedstate-plugin'
Vue.use(PiniaVuePlugin)
const pinia = createPinia()
pinia.use(createPersistedState()) //开启缓存，存储在localstorage
Vue.config.productionTip = false
new Vue({
  router,
  pinia,
  render: h => h(App),
}).$mount('#app')
